import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Accounts from './pages/Accounts';
import Users from './pages/Users';
import AccountDetail from './pages/AccountDetail';
import UserDetail from './pages/UserDetail';
import Actions from './pages/Actions';
import ActionDetail from './pages/ActionDetail';
import Alerts from './pages/Alerts';
import AlertDetail from './pages/AlertDetail';
import Sequences from './pages/Sequences';
import SequenceEditor from './pages/SequenceEditor';
import Personas from './pages/Personas';
import PersonaDetail from './pages/PersonaDetail';
import HubSpot from './pages/HubSpot';
import HubSpotListDetail from './pages/HubSpotListDetail';
import HubSpotContactDetail from './pages/HubSpotContactDetail';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/accounts" element={<Accounts data-id="element-6" />} data-id="element-5" />
          <Route path="/accounts/:id" element={<AccountDetail data-id="element-8" />} data-id="element-7" />
          <Route path="/users" element={<Users data-id="element-10" />} data-id="element-9" />
          <Route path="/users/:id" element={<UserDetail data-id="element-12" />} data-id="element-11" />
          <Route path="/actions" element={<Actions data-id="element-14" />} data-id="element-13" />
          <Route path="/actions/:id" element={<ActionDetail data-id="element-16" />} data-id="element-15" />
          <Route path="/alerts" element={<Alerts data-id="element-18" />} data-id="element-17" />
          <Route path="/alerts/:id" element={<AlertDetail data-id="element-20" />} data-id="element-19" />
          <Route path="/sequences" element={<Sequences data-id="element-22" />} data-id="element-21" />
          <Route path="/sequences/editor/:id" element={<SequenceEditor data-id="element-24" />} data-id="element-23" />
          <Route path="/sequences/editor/new" element={<SequenceEditor data-id="element-26" />} data-id="element-25" />
          <Route path="/personas" element={<Personas data-id="element-28" />} data-id="element-27" />
          <Route path="/personas/:id" element={<PersonaDetail data-id="element-30" />} data-id="element-29" />
          <Route path="/hubspot" element={<HubSpot data-id="element-32" />} data-id="element-31" />
          <Route path="/hubspot/lists/:id" element={<HubSpotListDetail data-id="element-34" />} data-id="element-33" />
          <Route path="/hubspot/contacts/:id" element={<HubSpotContactDetail data-id="element-36" />} data-id="element-35" />
        </Routes>
      </Layout>
    </Router>;
}